import { Step } from 'signup-constants/Step';
import { isProductisedSignupFlow } from '../../utils/gtkm/isProductisedSignupFlow';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { setFlow } from '../../store/flow/action-creators';
import { getCurrentStep } from '../../store/flow/selectors';
import { hasEndpointBeenFetched } from '../../store/http-responses/selectors';
import { EndpointKey } from '../../http/EndpointKey';
import { getPostGTKMFlowSU0004 } from '../../http-gtkm-company-info/updateStepOrderSU0004';
import { getShouldAddHubletSelection } from './BranchAddHubletNewUser';
import { getIsJapan } from '../../utils/getIsJapan';
export const BranchSU0004 = {
  name: 'BranchSU0004',
  stateCheck: state => isProductisedSignupFlow(state),
  rebuildFlow: (flow, state, dispatch) => {
    const currentStep = getCurrentStep(state);
    // currentStep is null after a reloadFlow() reset — treat it as a restart
    // so we land on LandingPage rather than slicing forward from a stale step.
    const isRestartingFlow = currentStep === null || currentStep === Step.ExistingUser;
    const gtkmFetched = hasEndpointBeenFetched(state, EndpointKey.GTKMCompanyInfoSU0004);

    // If GTKM has already responded, use the dynamic flow (may include CompanyDomain)
    if (gtkmFetched && !isRestartingFlow) {
      const allSteps = getPostGTKMFlowSU0004(state);
      if (currentStep) {
        const currentStepIndex = allSteps.indexOf(currentStep);
        return currentStepIndex >= 0 ? allSteps.slice(currentStepIndex + 1) : allSteps;
      }
      return allSteps;
    }
    const shouldAddPhoneNumber = getIsJapan(state);
    const preVerification = [Step.LandingPage, Step.CodeVerification];
    // LoadingPage bridges the first GTKM call so the user sees a spinner
    // instead of the Password form while company info is being prefilled.
    const postVerificationSteps = [Step.LoadingPage, Step.Password, Step.Name, Step.ManagementLevel, Step.Review, ...(shouldAddPhoneNumber ? [Step.PhoneNumber] : []), ...(getShouldAddHubletSelection(state) ? [Step.HubletSelection] : [])];
    // ProductSetupUIBranch may have appended InstallSalesExtension for intent
    // flows before this branch fires. Preserve it so it isn't wiped.
    const hasInstallSalesExtension = flow.includes(Step.InstallSalesExtension);
    const postAccountCreation = hasInstallSalesExtension ? [Step.InstallSalesExtension] : [];
    const postExistingAccountSelection = hasInstallSalesExtension ? [Step.InstallSalesExtension] : [];
    const nextSteps = [...(isPreVerification() ? preVerification : []), ...postVerificationSteps, ...(hasInstallSalesExtension ? [Step.InstallSalesExtension] : [])];
    dispatch(setFlow(nextSteps, preVerification, postVerificationSteps, postAccountCreation, postExistingAccountSelection, false));

    // After a reloadFlow() reset (currentStep === null) or when the user clicks
    // "Create new account" from ExistingUser, send them through the full flow
    // starting at LandingPage instead of slicing forward from a stale step.
    if (isRestartingFlow) {
      return nextSteps;
    }
    if (currentStep) {
      const currentStepIndex = nextSteps.indexOf(currentStep);
      if (currentStepIndex >= 0) {
        return nextSteps.slice(currentStepIndex + 1);
      }
      // currentStep is not in SU0004's flow (e.g. LoadingPage from another branch)
      // Return post-verification steps to move forward correctly
      return postVerificationSteps;
    }
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};